<template>
    <div class="card card-body" style="background-color: #f1f6fa">
        <div class="timeline timeline-5">
            <div class="timeline-items">
                <div v-for="item in timeLineItems" class="timeline-item"
                     :class="{'pb-20' : item.id < Object.keys(timeLineItems).length - 1}" :key="item.id">
                    <div class="timeline-media bg-primary">
                        <i v-if="item.finished" class="fas fa-check text-white"></i>
                        <span v-else class="text-white">{{ item.id + 1 }}</span>
                    </div>
                    <div class="timeline-desc timeline-desc-light-primary">
                        <span class="font-size-h5 font-weight-bold line-height-sm">{{ item.title }}</span>
                        <div v-if="activeIndex === item.id">
                            <p class="font-italic mt-5 text-muted">{{ item.description }}</p>

                            <!-- Slot for input field -->
                            <slot name="form"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <slot name="buttons"></slot>
    </div>
</template>

<script>
export default {
    props: {
        timeLineItems: Object,
        activeIndex: Number,
    },
};
</script>